import { AxiosError } from 'axios';
import { OAuthToken } from '@vsf-enterprise/sapcc-api';

export const shouldRefreshToken = (
  error: AxiosError,
  currentToken: OAuthToken | null
): boolean => {
  const { response } = error;

  if (!currentToken) return true;

  const authorizationHeader = response?.data.config.headers.Authorization;
  const failedWithCurrentToken = Boolean(authorizationHeader?.includes(currentToken.access_token));

  return failedWithCurrentToken;
};
